module.exports = __webpack_public_path__ + "static/media/touareg.57c374a0.png";